<template>
  <section class="filters-section">
    <div class="filters">
      <select v-model="localFilters.year" class="filter-select" @change="emitFilterChange('year', $event.target.value)">
        <option v-for="opt in filterOptions.year" :value="opt.value" :key="opt.value">
          {{ opt.text }}
        </option>
      </select>

      <select v-model="localFilters.port" class="filter-select" @change="emitFilterChange('port', $event.target.value)">
        <option v-for="opt in filterOptions.port" :value="opt.value" :key="opt.value">
          {{ opt.text }}
        </option>
      </select>

      <select v-model="localFilters.cruise" class="filter-select"
        @change="emitFilterChange('cruise', $event.target.value)">
        <option v-for="opt in filterOptions.cruise" :value="opt.value" :key="opt.value">
          {{ opt.text }}
        </option>
      </select>

      <select v-model="localFilters.ship" class="filter-select" @change="emitFilterChange('ship', $event.target.value)">
        <option v-for="opt in filterOptions.ship" :value="opt.value" :key="opt.value">
          {{ opt.text }}
        </option>
      </select>

      <select v-model="localFilters.date" class="filter-select" @change="emitFilterChange('date', $event.target.value)">
        <option v-for="opt in filterOptions.date" :value="opt.value" :key="opt.value">
          {{ opt.text }}
        </option>
      </select>

      <select v-model="localFilters.time" class="filter-select" @change="emitFilterChange('time', $event.target.value)">
        <option v-for="opt in filterOptions.time" :value="opt.value" :key="opt.value">
          {{ opt.text }}
        </option>
      </select>

      <select v-model="localFilters.tour" style="max-width: 1rem;" class="filter-select"
        @change="emitFilterChange('tour', $event.target.value)">
        <option v-for="opt in filterOptions.tour" :value="opt.value" :key="opt.value">
          {{ opt.text }}
        </option>
      </select>

      <span class="count">Tours: {{ filteredRowsCount }}</span>
      <button @click="handleReset" class="reset-btn">Reset</button>
    </div>
  </section>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  filters: {
    type: Object,
    required: true
  },
  filterOptions: {
    type: Object,
    required: true
  },
  filteredRowsCount: {
    type: Number,
    required: true
  }
})

const emit = defineEmits(['update-filter', 'reset-filters'])

const localFilters = ref({ ...props.filters })

// Sync local filters with parent filters
watch(
  () => props.filters,
  (newFilters) => {
    localFilters.value = { ...newFilters }
  },
  { deep: true }
)

const emitFilterChange = (filterName, value) => {
  emit('update-filter', filterName, value)
}

const handleReset = () => {
  emit('reset-filters')
}
</script>

<style scoped>
.filters-section {
  margin-bottom: 1.5rem;
}

.filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  background: white;
  padding: 0.75rem;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.filter-select {
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: white;
  font-size: 0.85rem;
  min-width: 140px;
}

.count {
  font-weight: 600;
  color: #4f46e5;
  padding: 0.5rem 0.75rem;
}

.reset-btn {
  padding: 0.5rem 1rem;
  background: #6366f1;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.85rem;
}

.reset-btn:hover {
  background: #4f46e5;
}

@media (max-width: 768px) {
  .filters {
    flex-direction: column;
  }
}
</style>